
/* ══ WARMUP STICKY BAR + WHATSAPP ══ */
document.addEventListener('DOMContentLoaded', function() {
  
  // Add WhatsApp button after product form
  const productForm = document.querySelector('.product-form, product-form');
  if (productForm && !document.querySelector('.warmup-wa-btn')) {
    const waBtn = document.createElement('button');
    waBtn.className = 'warmup-wa-btn';
    waBtn.innerHTML = '💬 اطلب عبر واتساب';
    waBtn.onclick = function() {
      const title = document.querySelector('.product__title, h1.title')?.textContent?.trim() || 'منتج';
      const url = window.location.href;
      window.open('https://wa.me/962792225298?text=' + encodeURIComponent('مرحباً، أريد أطلب: ' + title + ' - ' + url), '_blank');
    };
    productForm.parentNode.insertBefore(waBtn, productForm.nextSibling);
  }

  // Sticky Add to Cart bar
  const addToCartBtn = document.querySelector('.product-form__submit');
  if (addToCartBtn && !document.querySelector('.warmup-sticky-bar')) {
    // Create sticky bar
    const productTitle = document.querySelector('.product__title, h1.title')?.textContent?.trim() || '';
    const productImg = document.querySelector('.media-gallery__main img, .product__media img')?.src || '';
    const productPrice = document.querySelector('.price__sale .price-item--sale, .price-item--regular')?.textContent?.trim() || '';
    
    const bar = document.createElement('div');
    bar.className = 'warmup-sticky-bar';
    bar.innerHTML = `
      <div class="warmup-sticky-product">
        <img class="warmup-sticky-thumb" src="${productImg}" alt="">
        <div class="warmup-sticky-info">
          <div class="name">${productTitle.substring(0,30)}</div>
          <div class="price">${productPrice}</div>
        </div>
      </div>
      <button class="warmup-sticky-btn">أضف إلى السلة</button>
    `;
    document.body.appendChild(bar);
    
    // Show sticky bar when original button scrolls out of view
    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('visible', !entry.isIntersecting);
    }, { threshold: 0 });
    observer.observe(addToCartBtn);
    
    // Sticky btn clicks trigger original
    bar.querySelector('.warmup-sticky-btn').onclick = () => addToCartBtn.click();
  }
});
